import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { customerLinks, settingsLink } from 'config/links';
import 'styles/modules/navigation.module.scss';
import { connect } from 'react-redux';
import permissions, { checkPermissions } from 'config/permissions';
import { getAllowedPermission } from 'components/Styled/Permission';
import Control from '../Control';
import { isProduction } from 'utils/env';

export const hasAllowedGroup = (allowedGroups = [], groups = []) => {
	const normalizedGroups = Array.isArray(allowedGroups) ? allowedGroups : [allowedGroups];
	const normalizedUserGroups = Array.isArray(groups) ? groups : [];

	return normalizedGroups.some((group) => normalizedUserGroups.includes(group));
};

function mapStateToProps(state) {
	return {
		isSettingsButtonEnabled: checkPermissions(permissions.AdminGrantOperations.view_permissions),
		isKnowledgeBaseButtonEnabled: checkPermissions(permissions.UserOperations.action_clientPartViewKnowledgeBase),
		isDashboardEnabled: checkPermissions(permissions.DashboardOperations.dashboard_workWithDashboard),
		isIdentityEnabled: checkPermissions(permissions.AdminGrantOperations.action_manage_access),
		isOrdersEnabled: checkPermissions(permissions.OrderOperations.view_order),
		user: state.user,
	};
}

@withRouter
@connect(mapStateToProps)
class Navigation extends Component {
	constructor(props) {
		super(props);

		this.state = {
			logoError: false,
		};
	}

	render() {
		const {
			isKnowledgeBaseButtonEnabled,
			isSettingsButtonEnabled,
			isDashboardEnabled,
			isIdentityEnabled,
			isOrdersEnabled,
			user,
		} = this.props;

		return (
			<aside>
				<div>
					<div className="logo-container">
						<div className="container-menu">
							{this.state.logoError ? (
								<i className="icon-logo" />
							) : (
								<img
									alt="logo"
									src="/data/images/logo.png"
									onError={() => this.setState({ logoError: true })}
								/>
							)}
						</div>
					</div>

					<div className="sections-block">
						{customerLinks.map((item) => {
							const hasGroupAccess = hasAllowedGroup(item.groups, user?.groups);

							if (item.name === 'knowledge_base' && !isKnowledgeBaseButtonEnabled) {
								return null;
							}

							if (item.name === 'dashboard' && !isDashboardEnabled) {
								return null;
							}

							if (item.name === 'orders' && !isOrdersEnabled) {
								return null;
							}

							if (item.name === 'identity') {
								if (isIdentityEnabled) {
									return (
										<Control key={item.name}
											item={{
												...item,
												link: isProduction
													? 'https://sso.ukc.gov.ua/identity/admin'
													: 'http://sso-test.ukc.loc/identity/admin',
												blank: true,
											}}
										/>
									);
								}

								return null;
							}

							if (item.name === 'sds' && getAllowedPermission(item.permission, user?.operations)) {
								return (
									<Control key={item.name}
										item={{
												 ...item,
												 blank: true,
										}}
									/>
								);
							}

							if (item.permission
								&& !getAllowedPermission(item.permission, user?.operations)
								&& !hasGroupAccess) {
								return null;
							}

							return (
								<Control key={item.name}
									item={{
										...item,
										link: `/${item.name}`,
									}}
								/>
							);
						})}
					</div>
				</div>

				{isSettingsButtonEnabled && (
					<div>
						<div className="sections-block">
							<Control key="settings"
								item={settingsLink}
								onClick={(e) => {
									e.preventDefault();
								}}
							/>
						</div>
					</div>
				)}
			</aside>
		);
	}
}

Navigation.defaultProps = {
	isKnowledgeBaseButtonEnabled: false,
	isSettingsButtonEnabled: false,
};

Navigation.propTypes = {
	isDashboardEnabled: PropTypes.bool,
	isIdentityEnabled: PropTypes.bool,
	isKnowledgeBaseButtonEnabled: PropTypes.bool,
	isOrdersEnabled: PropTypes.bool,
	isSettingsButtonEnabled: PropTypes.bool,
	user: PropTypes.shape({
		groups: PropTypes.arrayOf(PropTypes.string),
		operations: PropTypes.arrayOf(PropTypes.string),
	}),
};

export default Navigation;
